module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/survive/2_points&steals-bb437f65766fdeaad6d0574e562ba997.svg";